import { getItemsPaginated } from "@/services/common";
import { getUploads } from '@/services/uploads';


export default {
  state: {
    uploadsInfo: {
      uploads: [],
      busy: false,
      pageNumber: 1,
      totalUploads: 0,
    }
  },
  mutations: {
    setUploadsPaginated(state, { results, count, pageNumber}) {
      state.uploadsInfo = { uploads: results, totalUploads: count, pageNumber, busy: false };
    },
    setUploadsLoadingIsBusy(state) {
      state.uploadsInfo.busy = true;
    },
  },
  actions: {
    async loadUploadsPaginated({ commit }, payload) {
      commit('setUploadsLoadingIsBusy');
      const { results, count } = await getItemsPaginated(getUploads, payload);
      const { pageNumber } = payload;
      commit('setUploadsPaginated', { results, count, pageNumber });
    },
  },
  getters: {
    uploads: state => state.uploadsInfo.uploads,
    uploadsBusy: state => state.uploadsInfo.busy,
    pageNumberUploads: state => state.uploadsInfo.pageNumber,
    totalUploads: state => state.uploadsInfo.totalUploads,
  }
}



// WEBPACK FOOTER //
// ./src/store/uploads.js